import React from "react";
import Box from "@mui/material/Box";

import RewampAccessibilityBar from "./RewampAccessibilityBar";
import RewampMasthead from "./RewampMasthead";
import RewampMainNav from "./RewampMainNav";

export const RewampAppBar = React.memo(({
  onIncreaseFontSize = () => { },
  onDecreaseFontSize = () => { },
  onResetFontSize = () => { },
  handleLogout = () => { },
}) => {
  return (
    <>
      <Box component="header" sx={{ width: "100%" }}>
        <RewampAccessibilityBar
          onIncreaseFontSize={onIncreaseFontSize}
          onDecreaseFontSize={onDecreaseFontSize}
          onResetFontSize={onResetFontSize}
        />
        <RewampMasthead />
      </Box>
      <RewampMainNav handleLogout={handleLogout} />
    </>
  );
});

export default RewampAppBar;
